/**
 * Audio playback for guided tour steps. Uses native HTMLAudioElement
 * (no extra deps).
 *
 * Tour MP3s live under `assets/audio/<tour>/<step>.mp3`. We use webpack's
 * require.context at build time so every file ships with the bundle as
 * a hashed URL — no runtime fetching.
 *
 * Browser autoplay policy: the first step after the user taps "Start"
 * plays fine because the click is an active user gesture. Only edge
 * case: if the tour auto-starts on page load without any interaction,
 * the first play() will reject — we catch that silently and the user
 * can tap the mute button (which also triggers play() on unmute) to
 * unlock audio.
 */

// require.context walks the whole assets/audio folder at build time.
const ctx = require.context("./assets/audio", true, /\.mp3$/);
const CACHE = {};
ctx.keys().forEach((k) => {
  // k: "./services/services.step1.mp3"
  const [, tourId, fileName] = k.match(/^\.\/([^/]+)\/(.+?)\.mp3$/) || [];
  if (!tourId || !fileName) return;
  CACHE[fileName] = ctx(k);
});

let currentAudio = null;
let muted = false;

export const setMuted = (v) => {
  muted = !!v;
  if (muted && currentAudio) currentAudio.pause();
};

export const isMuted = () => muted;

/**
 * Play the MP3 for a step. Returns the audio element (or null if
 * no file exists). Stops any currently-playing step audio.
 */
export const playStep = (stepId) => {
  const url = CACHE[stepId];
  stopStep();
  if (!url || muted) return null;
  const audio = new Audio(url);
  audio.volume = 0.9;
  audio.play().catch(() => {
    // Autoplay blocked — ignored; user can tap mute-toggle to unlock.
  });
  currentAudio = audio;
  return audio;
};

export const stopStep = () => {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }
};

export const hasAudio = (stepId) => !!CACHE[stepId];
